$(document).ready(function () {
    function myFunction(x) {
        if (x.matches && $('.sidebar').hasClass('active')) { // If media query matches
            $(' body').addClass('overflow-hidden');
        } else {
            $(' body').removeClass('overflow-hidden');
        }
    }

    var x = window.matchMedia("(max-width: 820px)")
    myFunction(x)
    x.addListener(myFunction)

    $(document).on('click', '.btn-menu', function () {
        $('.sidebar').addClass('active');
        $('.btn-menu').css('display', 'none');
        $('.btn-close-sidebar').css('display', 'flex');
        $(' body').addClass('overflow-hidden');
    });

    $(document).on('click', '.btn-close-sidebar', function () {
        $('.sidebar').removeClass('active');
        $('.btn-menu').css('display', 'flex');
        $('.btn-close-sidebar').css('display', 'none');
        $(' body').removeClass('overflow-hidden');
    });

    $('.sub-btn').click(function () {
        $(this).next('.sub-menu').slideToggle();
        $(this).find('.dropdown').toggleClass('rotate');
    })

    $(document).on('click', '.btn-back-to-top', function () {
        $('html, body').animate({scrollTop: 0}, 1000);
    })

    document.querySelectorAll('.dropdown-toggle').forEach(dropDownFunc);

    function dropDownFunc(dropDown) {

        if (dropDown.classList.contains('click-dropdown') === true) {
            dropDown.addEventListener('click', function (e) {
                e.preventDefault();

                if (this.nextElementSibling.classList.contains('dropdown-active') === true) {
                    this.parentElement.classList.remove('dropdown-open');
                    this.nextElementSibling.classList.remove('dropdown-active');

                } else {
                    closeDropdown();

                    this.parentElement.classList.add('dropdown-open');
                    this.nextElementSibling.classList.add('dropdown-active');
                }
            });
        }

        window.addEventListener('click', function (e) {
            if (e.target.closest('.dropdown-container') === null) {
                closeDropdown();
            }
        });


        function closeDropdown() {

            document.querySelectorAll('.dropdown-container').forEach(function (container) {
                container.classList.remove('dropdown-open')
            });

            document.querySelectorAll('.dropdown-menu').forEach(function (menu) {
                menu.classList.remove('dropdown-active');
            });
        }

        document.querySelectorAll('.dropdown-menu').forEach(function (dropDownList) {
            dropDownList.onmouseleave = closeDropdown;
        });

    }

    if (window.location.href == $('.route-participant-note').val()) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#focus-participant-note').offset().top - 100
        }, 500);
    }

    $(document).on('click', '.noti-bid-permission .icon-close', function () {
        $(this).closest('.noti-bid-permission').addClass('d-none')
    })

    $(document).on('click', '.noti-bid-permission', function (event) {
        if (!($(event.target).closest('.modal-1').length)) {
            $(this).closest('.noti-bid-permission').addClass('d-none')
        }
    })

    $(document).on('click', '.auction-detail #auction-company', function () {
        $('.auction-company').removeClass('d-none');
    })

    $(document).on('click', '.collapse-content-notification', function () {
        $(this).parent().parent().find('.content-notification').toggleClass('d-none');
        $(this).parent().find('img').removeClass('d-none');
        $(this).addClass('d-none');
    })

    $('#modalCanNotSubmitPreBid').on('hidden.bs.modal', function (e) {
        location.reload();
    })

});
